import React from "react";
import YxText from "../../YxText";
import YxPanel from "../../YxPanel";
import YxAction from "../../YxAction";
import { YxComponent } from "../../YxComponent";
import { get, merge, nodeFactory } from "../../../utils";
import { isEqual, omit } from "lodash";

class YxInputAction extends YxComponent {
  constructor(props) {
    super(props);
    this.childrenSubmit = () => {};
    this.form = null;
    this.state = {
      tabs: [],
      componet: false,
    };
    this.divClass = "yx_popup_box";
    this.value = this.props.value;
    this.oldValues = this.props.value;
    this.getValues = () => {};
  }

  componentDidMount() {
    this.asyncSetState({ componet: true });
  }

  get modalParam() {
    const result = {
      load: ({ submit, form, tabs, getValues }) => {
        this.childrenSubmit = submit;
        this.form = form;
        this.setState({ tabs: tabs || [] });
        this.getValues = getValues;
        get(this.props, "actionLoad", () => {})({ submit });
      },
      popup: get(this.props, "popup"),
      formValue: get(this.props, "value", null),
      formItemId: get(this.props, "id", null),
      change: get(this.props, "onChange", () => {}),
      onForm: this.componentMouseLeave,
      rules: get(this.props, "rules", {}),
    };
    return merge(result, get(this.props, "iocParam", {}));
  }

  onOk = async () => {
    const values = await this.childrenSubmit();
    const id = get(this.props, "id", null);
    console.log("确定回调", values);
    if (values == null) {
      return false;
    } else {
      get(this.props, "onChange", () => {})(values, id);
      get(this.props, "change", () => {})(values, id);
    }
  };

  get textParam() {
    const textParam = get(this.props, "textParam", null);
    if (textParam instanceof Function) {
      return textParam(this.props, this.state);
    }
    return textParam;
  }

  productionText = () => {
    const formValue = get(this.props, "value", null);
    if (formValue == null) {
      return null;
    } else {
      const textParam = this.textParam;
      if (textParam == null) {
        return null;
      }
      const type = get(textParam, "controlType", "String");
      const DOM = YxText[type];
      return <DOM value={formValue} children={formValue} {...textParam} />;
    }
  };

  /**
   * 鼠标移开，判断值是否不等，不等则提交
   *
   * @memberof YxInputAction
   */
  componentMouseLeave = (value) => {
    const values = this.getValues();
    if (!isEqual(values, this.oldValues)) {
      this.oldValues = values;
      const id = get(this.props, "id", null);
      get(this.props, "onChange", () => {})(values, id);
      get(this.props, "change", () => {})(values, id);
    }
  };

  get panelClassName() {
    const { popup } = this.props;
    if (popup === false) {
      return "panel_popup_no_pading";
    }
    return "";
  }

  renderComponent = () => {
    const Component = this.props.DOM;
    const text = get(this.props, ["text", "label"], "-");
    const containerParam = { onMouseLeave: this.componentMouseLeave };
    // const DOM = <YxPanel header={text} contentextra='padding' className={this.panelClassName} styleParam={{ type: 'border' }} >
    //   {this.state.componet && <Component {...this.modalParam} />}
    // </YxPanel>
    const DOM = (
      <div className={`yx_org_p_form_no_padding special_margin`}>
        {this.state.componet && <Component {...this.modalParam} />}
      </div>
    );
    return DOM;
  };

  domSelect = () => {
    const popup = get(this.props, "popup", true);
    const styleType =
      get(this.props, "iocParam.item.styleType", null) ||
      get(this.props, "styleType", "button");
    const inputParams = get(this.props, "iocParam.item.inputParams", {});
    const popupParam = get(this.props, "popupParam", {});
    // null 使用自动撑开
    // undefined 使用默认antd 默认宽度
    // width 设置固定宽度
    const Component = this.props.DOM;
    if (popup === true) {
      const text = get(this.props, "text", "弹出框");
      let modalParam = this.modalParam;
      delete modalParam.onForm;
      const param = {
        text,
        actionType: "popup",
        styleType,
        inputParams,
        popupParam: {
          title: text,
          okText: "确定",
          width: popupParam.width,
          onOk: this.onOk,
          children: (
            <div className={`special_drawer`}>
              <Component {...modalParam} />
            </div>
          ),
        },
      };
      const DOM = (
        <YxAction
          {...omit(merge(param, this.props), [
            "inputType",
            "activeType",
            "textParam",
            "nolabel",
            "actionLoad",
            "DOM",
          ])}
        />
      );
      return DOM;
    }
    return this.renderComponent();
  };

  render() {
    return (
      <div className={this.parentClass}>
        {this.productionText()}
        {this.domSelect()}
      </div>
    );
  }
}

export default YxInputAction;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Popup/Action.js